import { useEffect, useState } from 'react'
import { getLmsInsightConnections, getLmsInsightDetails } from '../../../api-new/state/analytics'
import { FALLBACK_TIME_ZONE, detailsQuery } from './lms-insight-query'
import { failureOf, isBadFilter } from './use-lms-reports'

// What the filter bar offers: the organization's LMS connections (archived
// ones included) and the courses mapped on them (the one connection's, once
// one is chosen), with the intervals and the longest range the service reads.
// A list that cannot be read is an empty list: the bar then offers only "all",
// and the reports say what is wrong. `unavailable` is the organization that
// has no LMS insights at all. `zoneRejected` is the service refusing the zone
// asked for (400 bad_filter on /details: PostgreSQL does not know it), for the
// page to read in UTC instead; a refusal of UTC itself is not that.
export const useInsightOptions = ({ tz, connection, refreshKey }) => {
  const [connections, updateConnections] = useState({ status: 'loading', items: [] })
  const [details, updateDetails] = useState({ status: 'loading', body: null, tz: null, zoneRejected: false })

  useEffect(() => {
    let live = true
    getLmsInsightConnections().then(
      body => live && updateConnections({ status: 'ready', items: body && Array.isArray(body.connections) ? body.connections : [] }),
      error => live && updateConnections({ status: failureOf(error).status, items: [] })
    )
    return () => { live = false }
  }, [refreshKey])

  useEffect(() => {
    let live = true
    getLmsInsightDetails(detailsQuery({ tz, connection })).then(
      body => live && updateDetails({ status: 'ready', body, tz, zoneRejected: false }),
      error => live && updateDetails({ status: failureOf(error).status, body: null, tz, zoneRejected: tz !== FALLBACK_TIME_ZONE && isBadFilter(error) })
    )
    return () => { live = false }
  }, [tz, connection, refreshKey])

  const body = details.body || {}

  return {
    connections: connections.items,
    courses: Array.isArray(body.courses) ? body.courses : [],
    intervals: Array.isArray(body.intervals) && body.intervals.length ? body.intervals : undefined,
    maxRangeDays: typeof body.maxRangeDays === 'number' ? body.maxRangeDays : undefined,
    unavailable: connections.status === 'unavailable' || details.status === 'unavailable',
    // an answer to an earlier zone is not about this one
    zoneRejected: details.zoneRejected && details.tz === tz
  }
}
